export function clientType () {
  const isIOS = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)
  if (isIOS) return 'ios'
  const isAndroid = /(Android)/i.test(navigator.userAgent)
  if (isAndroid) return 'android'
  return 'pc'
}
export function stat (type, action, data) {
  xla.push({
    type,
    category: 'page_event',
    action,
    extdata: {
      clientType: clientType(),
      sourceType: 'resource_swap',
      pageType: 'welfare',
      ...data
    }
  })
}
